import * as api from '../Api'

export const allYearData=()=>async(dispatch)=>{
    try {
        const {data} = await api.yearData();
        dispatch({type:"ALL_YEAR_DATA",payload:data});
    } catch (error) {
        
    }
}